import { DesktopWindow, WindowTitleBar } from "../../desktopWindow/components/DesktopWindow";
import EmailContainer from "./EmailContainer";

import MailIcon from "../../assets/img/game-room/mail.png";
import { GameTutorialElements } from "../../gameTutorial/types";

interface Props {
	// Window tile id
	tileId: string;
}
export const EmailWindow = ({ tileId }: Props) => {
	return (
		<DesktopWindow id={tileId} className={GameTutorialElements.EMAIL_BROWSER_WINDOW}>
			<WindowTitleBar icon={<img src={MailIcon} alt="mail" height="30" width="30" />} />
			<EmailContainer />
		</DesktopWindow>
	);
};
